//Install
import React, { Component } from "react";
//Install
import { ReactComponent as FA8114 } from "../../Media/Icon/001.svg";

//Element
class World extends Component {
    //Element
    onClick = (e) => {
        //Element
        e.preventDefault()
        //Element
        let WorldWide = document.getElementsByClassName( "h01g8q" )[0]
        //Element
        WorldWide.classList.toggle( "d-none" )
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("button", { id: "Web_E81228", name: "Web_E81228", className: "S0u16d C96Q4r U080Kf d721Vx pEO064 a527eB o84y82", type: "button", onClick: this.onClick },
            //Element
            React.createElement( "span", { className: "g4i93a" },
                //Element
                "Türkiye"
            ),
            //Element
            React.createElement(FA8114, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default World;